
import {
  createPopperLite as createPopper,
  preventOverflow,
  arrow,
  offset,
  flip,
} from '@popperjs/core'
import componentInstanceId from '~/mixins/component-instance-id'
import RemoveIcon from '~/assets/images/remove-icon.svg?inline'

export default {
  components: {
    RemoveIcon,
  },
  mixins: [componentInstanceId('tooltip')],
  props: {
    positioningStrategy: {
      type: String,
      default: 'absolute',
    },
    placement: {
      type: String,
      default: 'top',
    },
    markText: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: '30ch',
    },
    variant: {
      type: String,
      default: 'info',
    },
  },
  data() {
    return {
      shown: false,
    }
  },
  watch: {
    positioningStrategy(newValue) {
      this.popper?.setOptions({
        ...this.getPopperOptions(),
        strategy: newValue,
      })
    },
    placement(newValue) {
      this.popper?.setOptions({
        ...this.getPopperOptions(),
        placement: newValue,
      })
    },
  },
  destroyed() {
    this.destroyPopper()
  },
  methods: {
    getPopperOptions() {
      return {
        placement: this.placement,
        strategy: this.positioningStrategy,
        modifiers: [
          preventOverflow,
          flip,
          { ...arrow, options: { padding: 8 } },
          { ...offset, options: { offset: [0, 20] } },
        ],
      }
    },
    getAnchorElement() {
      let anchor = this.$el.querySelector(':scope > [data-anchor]')
      if (!anchor) {
        anchor = this.$el.querySelector(':scope > *:first-child')
      }
      if (!anchor) {
        throw new Error(
          'No anchor found for tooltip! The anchor should be either an element with a data-anchor attribute or the first child of the tooltip container.',
        )
      }
      return anchor
    },
    createPopper() {
      if (this.popper || !this.shown) {
        return
      }

      this.popper = createPopper(
        this.getAnchorElement(),
        this.$refs.tooltip,
        this.getPopperOptions(),
      )
    },
    destroyPopper() {
      if (!this.popper || this.shown) {
        return
      }
      this.popper.destroy()
      this.popper = null
    },
    show() {
      if (this.shown) {
        return
      }
      this.shown = true
      this.$nextTick(() => {
        this.createPopper()
      })
    },
    hide() {
      if (!this.shown) {
        return
      }
      this.shown = false
    },
    isDescendantOfTooltip(element) {
      return (
        element === this.$refs.tooltip || this.$refs.tooltip.contains(element)
      )
    },
    onMouseOver(e) {
      if (!this.isDescendantOfTooltip(e.target)) {
        this.show()
      }
    },
    onMouseOut(e) {
      if (
        !this.$el.contains(e.relatedTarget) ||
        this.isDescendantOfTooltip(e.relatedTarget)
      ) {
        this.hide()
      }
    },
  },
}
